import { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckIcon from '@mui/icons-material/Check';
import { TranslatedLanguagesCodes, READABLE_TRANSLATED_LANGUAGES } from 'root/src/shared/language/translatedLanguages.fixtures';
import { FLAG_COMPONENTS } from 'root/src/client/web/misc/LanguageSwitcher';
import { useLanguage } from 'root/src/client/v2/browser/hooks/useLanguage';
import { Popover, PopoverTrigger, PopoverContent } from 'root/src/client/v2/common/components/ui/popover';
import { cn } from 'root/src/client/v2/common/helpers/cn';
const LANGUAGES = Object.values(TranslatedLanguagesCodes).map(code => ({
    code,
    name: READABLE_TRANSLATED_LANGUAGES[code],
    Flag: FLAG_COMPONENTS[code],
}));
export const LanguageDropdown = () => {
    var _a;
    const { languageCode, languageSwitchHandler } = useLanguage();
    const [open, setOpen] = useState(false);
    const current = (_a = LANGUAGES.find(lang => lang.code === languageCode)) !== null && _a !== void 0 ? _a : LANGUAGES[0];
    const CurrentFlag = current.Flag;
    return (<Popover open={open} onOpenChange={setOpen}>
			<PopoverTrigger asChild>
				<button type="button" aria-label="Change language" className="flex h-8 items-center gap-1.5 rounded-md px-2 text-muted-foreground transition-colors hover:bg-white/[0.06] hover:text-foreground">
					<CurrentFlag className="h-3.5 w-5 rounded-sm"/>
					<span className="text-xs font-medium uppercase">{current.code}</span>
					<ExpandMoreIcon sx={{ fontSize: 14 }} className="opacity-50"/>
				</button>
			</PopoverTrigger>
			<PopoverContent align="end" className="w-48 p-1.5">
				{LANGUAGES.map((lang) => {
            const { Flag } = lang;
            const active = lang.code === languageCode;
            return (<button key={lang.code} type="button" onClick={() => {
                    setOpen(false);
                    languageSwitchHandler(lang.code);
                }} className={cn('flex w-full items-center gap-2.5 rounded-md px-2.5 py-1.5 text-left text-sm transition-colors hover:bg-white/[0.06]', active ? 'text-foreground' : 'text-muted-foreground hover:text-foreground')}>
							<Flag className="h-3.5 w-5 shrink-0 rounded-sm"/>
							<span className="min-w-0 flex-1 truncate">{lang.name}</span>
							{active && <CheckIcon sx={{ fontSize: 14 }} className="shrink-0 text-neon-cyan"/>}
						</button>);
        })}
			</PopoverContent>
		</Popover>);
};
